import { jsx as _jsx } from "react/jsx-runtime";
import { textClass } from "../tokens/scale.js";
import { cx } from "./cx.js";
const TONE = {
    ink: "t-ink",
    ink2: "t-ink-2",
    ink3: "t-ink-3",
    onMark: "t-on-mark",
    onBand: "t-on-band",
    onBandFaint: "t-on-band-faint",
    due: "t-due",
    accent: "hl hl-accent",
    note: "hl hl-note",
    alert: "hl hl-alert",
    cool: "hl hl-cool",
};
export function Text({ as: Tag = "span", style = "bodyUi", emphasized = false, tone, numeric = false, className, css, id, children, }) {
    return (_jsx(Tag, { id: id, className: cx(textClass(style), tone && TONE[tone], emphasized && "em", numeric && "num", className), style: { margin: 0, ...css }, "data-text-style": style, children: children }));
}
//# sourceMappingURL=Text.js.map